var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"active-box",on:{"click":_vm.handle2Active}},[_c('div',{staticClass:"title"},[_c('span',{class:_vm.active.type === 1
          ? 'span2'
          : _vm.active.type === 2
          ? 'span1'
          : _vm.active.type === 3
          ? 'span3'
          : _vm.active.type === 4
          ? 'span4'
          : _vm.active.type === 5
          ? 'span4'
          : 'span5'},[_vm._v(_vm._s(_vm._f("type")(_vm.active.type)))]),_c('span',{staticClass:"van-ellipsis"},[_vm._v(_vm._s(_vm.active.title))]),_c('span',[_vm._v(_vm._s(_vm.startOrEndText(_vm.active)))])]),_c('div',{staticClass:"date"},[_c('span',[_vm._v(_vm._s(_vm.active.time))]),_vm._m(0)]),_c('div',{staticClass:"author"},[_vm._v(_vm._s(_vm.active.user_name)+" | 主讲")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{attrs:{"src":require("@/assets/image/home/more.png"),"alt":""}})])}]

export { render, staticRenderFns }